import { Button } from "@mui/material";

import { ReactComponent as MessageSvg } from "../../assets/Messages.svg";
// import { ReactComponent as UserSvg } from "../../assets/User.svg";
import { ReactComponent as VerticalDivider } from "../../assets/VerticalDivider.svg";

function UserCard(props) {
  return (
    <div className="userCard bxShadow">
      <div className="userInfo">
        <div className="bioWrapper">
          <div className="imageWrapper">
            <div className="mainImage">
              {/* <UserSvg /> */}
            </div>
            <div className="online"></div>
          </div>
          <div className="names">
            <div className="primary">{props.user.givenname} {props.user.surname}</div>
            <div className="secondary">
              <div className="status">Status: Online</div>
              <div className="vDivider">
                <VerticalDivider />
              </div>
              <div className="status">Rolle: Administrator</div>
            </div>
          </div>
        </div>
      </div>

      <div className="email">{props.user.email}</div>
      <div className="phones">
        <div className="phone1">+49 176 123456</div>
        <div className="vDivider">
          <VerticalDivider />
        </div>
        <div className="phone2">+49 8141 123456</div>
      </div>

      <Button startIcon={<MessageSvg />} sx={{ marginTop:"16px"}} variant="outlined">
        neue nachricht
      </Button>
    </div>
  );
}

export default UserCard;
